/* MERGEsouq homepage scripts: slideshow, product tabs, quick add to cart, hotspots */
(function () {
  if (window.__msHomeLoaded) return;
  window.__msHomeLoaded = true;

  function initSlider(root) {
    if (root.__msInit) return;
    root.__msInit = true;
    var slides = [].slice.call(root.querySelectorAll('.ms-hero__slide'));
    var dots = [].slice.call(root.querySelectorAll('.ms-hero__dot'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function play() { stop(); if (root.getAttribute('data-autoplay') === 'true') timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var prev = root.querySelector('.ms-hero__arrow--prev'), next = root.querySelector('.ms-hero__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); }
      x0 = null;
    });
    go(0); play();
  }

  function initTabs(root) {
    if (root.__msInit) return;
    root.__msInit = true;
    var tabs = [].slice.call(root.querySelectorAll('.ms-tab'));
    var panels = [].slice.call(root.querySelectorAll('.ms-tabpanel'));
    tabs.forEach(function (t, j) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.classList.toggle('is-active', k === j); x.setAttribute('aria-selected', k === j ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.hidden = k !== j; });
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', count);
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('visible', count > 0);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ms-atc]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('ms:cart:added', { detail: cart }));
        if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); }
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added'); } }, 2000);
      })
      .catch(function () { form.removeAttribute('data-ms-atc'); form.submit(); });
  });

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ms-hotspot__dot');
    document.querySelectorAll('.ms-hotspot.is-open').forEach(function (h) { if (!dot || h !== dot.parentElement) h.classList.remove('is-open'); });
    if (dot) { e.preventDefault(); dot.parentElement.classList.toggle('is-open'); }
  });

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ms-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-ms-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
